(() => {
  if (customElements.get('hatchill-delivery-date')) return;

  function estimatedArrival(now) {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Africa/Cairo', year: 'numeric', month: 'numeric', day: 'numeric',
    }).formatToParts(now);
    const value = name => Number(parts.find(part => part.type === name).value);
    const arrival = new Date(Date.UTC(value('year'), value('month') - 1, value('day') + 1, 12));
    if (arrival.getUTCDay() === 5) arrival.setUTCDate(arrival.getUTCDate() + 1);
    return arrival;
  }

  class DeliveryDate extends HTMLElement {
    connectedCallback() {
      this.refresh = () => {
        const date = estimatedArrival(new Date());
        const formatted = new Intl.DateTimeFormat(this.lang || document.documentElement.lang || 'en', {
          timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short',
        }).format(date);
        const text = `${this.dataset.label}: ${formatted}`;
        if (this.textContent !== text) this.textContent = text;
        this.dataset.estimatedDate = date.toISOString().slice(0, 10);
        this.hidden = false;
      };
      this.refresh();
      this.timer = setInterval(this.refresh, 60000);
      document.addEventListener('visibilitychange', this.refresh);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.refresh);
    }
  }
  customElements.define('hatchill-delivery-date', DeliveryDate);
})();
